class Menu {
    constructor(el, settings) {
        this.DOM = {
            el,
            titlesInner: el.querySelector('.background-lettering'),
            mainMenuItems: Array.from(el.querySelectorAll('.menu-item')),
            sideMenuItems: Array.from(document.querySelectorAll('.vertical-anchor')),
            subMenu: el.querySelector('.sub-menu'),
            socialMenu: el.querySelector('.social-networks'),
            toggleButton: document.getElementById('navToggle')
        };

        this.mousePos = {};
        this.winsize = {};

        this.scale = 1;
        this.lastScale = 1;

        this.isAnimating = false;
        this.open = false;

        this.default = {};
        this.settings = Object.assign(this.default, settings);
        this.bindEvents();
    }

    bindEvents() {
        window.addEventListener('scroll', (ev) => {
            if (this.open && !window.helpers.isMobile()) {
                ev.preventDefault();
                this.close();

                const page = document.getElementById('page');
                const nextSection = page.querySelector('section:nth-of-type(2)');

                if (typeof nextSection === 'undefined' || !nextSection) {
                    return;
                }

                TweenMax.to(window, 2, { scrollTo: '#' + nextSection.getAttribute('id') });
            }
        });

        window.addEventListener('keyup', (ev) => {
            if (ev.keyCode === 27 && this.open) {
                this.close();
            }
        });

        this.calcWinsize();
        window.addEventListener('resize', this.calcWinsize);

        this.mousePos = { x: this.winsize.width / 2, y: this.winsize.height / 2 };

        if (!window.helpers.isMobile()) {
            window.addEventListener('mousemove', (ev) => {
                this.mousePos = this.render(ev);
            });
        }
    }

    toggle() {
        if (this.open) {
            this.close();
        }
        else {
            this.show();
        }
    }

    show() {
        this.open = true;
        this.DOM.toggleButton.classList.add('open');

        TweenMax.fromTo(
            this.DOM.el,
            0.6,
            { opacity: 0, zIndex: -1 },
            { opacity: 1, zIndex: 999, transformOrigin: '0% 100%', ease: Power2.easeOut, pointerEvents: 'auto', visibility: 'visible' }
        );

        this.DOM.mainMenuItems.forEach((el, pos) => {
            TweenMax.fromTo(el, 0.5, {
                ease: Quint.easeOut,
                y: `10${pos}%`,
                opacity: 0
            }, {
                y: '0%',
                opacity: 1,
                delay: 0.5,
                onComplete: () => {
                    this.animationEnd(pos);
                }
            });

            TweenMax.fromTo(this.DOM.socialMenu, 0.5, {
                ease: Quint.easeOut,
                y: '110%',
                opacity: 0
            }, {
                y: '0%',
                opacity: 1,
                delay: 0.5
            });

            TweenMax.fromTo(this.DOM.subMenu, 0.5, {
                ease: Quint.easeOut,
                opacity: 0
            }, {
                opacity: 1,
                delay: 1
            });
        });

        if (this.DOM.sideMenuItems.length) {
            this.DOM.sideMenuItems.forEach((el, pos) => {
                TweenMax.fromTo(el, 0.5, { opacity: 1 }, { opacity: 0 });
            });
        }
    }

    close() {
        const body = document.body;
        const scrollY = body.style.top;
        body.style.position = '';
        body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);

        this.open = false;
        this.DOM.toggleButton.classList.remove('open');

        TweenMax.fromTo(
            this.DOM.el,
            0.3,
            { opacity: 1, transformOrigin: '0% 100%', ease: Power2.easeOut, zIndex: 9 },
            { opacity: 0, delay: 0.5, zIndex: -1, pointerEvents: 'none', visibility: 'hidden' },
        );

        this.DOM.mainMenuItems.forEach((el, pos) => {
            TweenMax.fromTo(el, 0.3, {
                ease: Quint.easeOut,
                y: '0%',
                opacity: 1
            }, {
                y: `-10${pos}%`,
                opacity: 0,
                onComplete: () => {
                    this.animationEnd(pos);
                }
            });

            TweenMax.fromTo(this.DOM.socialMenu, 0.5, {
                ease: Quint.easeOut,
                y: '0%',
                opacity: 1
            }, {
                y: '110%',
                opacity: 0
            });

            TweenMax.fromTo(this.DOM.subMenu, 0.5, {
                ease: Quint.easeOut,
                opacity: 1
            }, {
                opacity: 0
            });
        });

        if (this.DOM.sideMenuItems.length) {
            this.DOM.sideMenuItems.forEach((el, pos) => {
                TweenMax.fromTo(el, 0.5, { opacity: 0 }, { opacity: 1 });
            });
        }
    }

    calcWinsize() {
        this.winsize = { width: window.innerWidth, height: window.innerHeight };
    }

    render(event) {
        const body = document.body;
        const mouseMoveVals = { translation: 0, rotation: -8 };

        let ev = event;
        let posx = 0;
        let posy = 0;

        if (!ev) {
            ev = window.event;
        }

        if (ev.pageX || ev.pageY) {
            posx = ev.pageX;
            posy = ev.pageY;
        }
        else if (ev.clientX || ev.clientY) {
            posx = ev.clientX + body.scrollLeft + this.DOM.titlesInner.scrollLeft;
            posy = ev.clientY + body.scrollTop + this.DOM.titlesInner.scrollTop;
        }

        this.mousePos = { x: posx, y: posy };

        mouseMoveVals.translation = window.MathUtils.lerp(
            mouseMoveVals.translation, window.MathUtils.lineEq(-30, 30, this.winsize.width, 0, this.mousePos.x),
            0.2
        );

        TweenMax.set(this.DOM.titlesInner, { x: 8 * mouseMoveVals.translation });
    }

    animationEnd(pos) {
        if (pos === this.DOM.mainMenuItems.length - 1) {
            this.isAnimating = false;
        }
    }
}
